<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLangStore } from '@/stores/langStore'

export default defineComponent({
  name: 'LocaleComponent',
  setup() {
    const { locale } = useI18n()
    const langStore = useLangStore()

    const switchLocale = (localeValue: string) => {
      langStore.setSelectedLanguage(localeValue)
      locale.value = localeValue
    }

    return {
      switchLocale,
    }
  },
})
</script>

<template>
  <div class="locale-container">
    <a
      :class="{
        'active-color': $i18n.locale === 'ru',
        'visited-color': $i18n.locale !== 'ru',
      }"
      @click="switchLocale('ru')"
    >Русский язык</a>
    <a
      :class="{
        'active-color': $i18n.locale === 'kz',
        'visited-color': $i18n.locale !== 'kz',
      }"
      @click="switchLocale('kz')"
    >Қазақ тілі</a>
    <a
      :class="{
        'active-color': $i18n.locale === 'en',
        'visited-color': $i18n.locale !== 'en',
      }"
      @click="switchLocale('en')"
    >English</a>
  </div>
</template>

<style scoped lang="scss">
.locale-container {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;

  .active-color {
    color: var(--color-text-primary);
  }

  .visited-color {
    color: var(--color-paragraph);
  }

  & a {
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
  }
}
</style>
